//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SingleMobileMarket from '~/components/detail/desktop/single_mobile_market'
import SingleLoading from '~/components/partials/loading/single_loading'
export default {
  name: 'CoinsList',
  components: { SingleLoading, SingleMobileMarket },
  data () {
    return {
      markets: null,
      loading: false,
      coinsPrices: null
    }
  },
  created () {
    this.getMarkets()
  },
  methods: {
    getMarkets () {
      this.$store.dispatch('axios/get', { url: '/market/list', config: { baseURL: process.env.BASE_EXCHANGE_URL } })
        .then(async (res) => {
          this.markets = res.data.data.markets.slice(0, 15)
          const pairs = this.markets.map(item => item.symbol)
          await this.$store.dispatch('axios/get', {
            url: '/application/coin/priceList',
            config: {
              baseURL: process.env.BASE_URL,
              params: { symbols: pairs.join() }
            }
          })
            .then((resp) => {
              this.coinsPrices = resp.data.data
            })
        }).catch((e) => {
          return e
        })
    }
  }
}
